import { IFair } from '@bridebook/web/app-shared/lib/supplier/types';

export const sortFairsByDate = (fairs?: IFair[]) =>
  [...(fairs || [])].sort((a, b) => a.dates[0] - b.dates[0]);
